import axios from "axios";
import { oidcConfig } from "../utils/oidcConfig";

 const api = axios.create({
    baseURL: oidcConfig.authority,
});


export default api;
